import {
    CircularProgress,
    FormControl,
    Select,
    TextField,
    Checkbox,
    Autocomplete,
} from "@mui/material";
import { Grid } from "@mui/system";
import { FormatDate, GetCurrentDateAndTime, GetDefaultDate } from "commonFunctions/commonFunctions";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";
import React, { useContext, useEffect, useMemo, useState } from "react";
import api from "utils/API/api";
import * as c from "utils/constants/constants";
import { EhrOrdersTable } from ".";

const Orders = (props) => {
    const { data = {}, setDocumentData, setDataSave } = useContext(DocumentDetailContext);
    const defaultDates = GetDefaultDate({ duration: 3, type: "month", format: "MM/DD/YYYY" });
    const [orderFilters, setOrderFilters] = useState({ status: "Active"});
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [dateError, setDateError] = useState(false);
    const [pagination, setPagination] = useState({ recordsPerPage: 50, currentPage: 0, totalRecords: 0, startRecord: 0 });
    const [ordersData, setOrdersData] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [orderCategoryList, setOrderCategoryList] = useState([]);
    const [loader, setLoader] = useState(false)

    const selectedCategory = useMemo(() => (orderCategoryList.find(m => m.id == orderFilters.category)), [orderFilters])

    useEffect(() => {
        const { ehrDetails: { order = {} } = {}, classify: { documentLevel } = {} } = data?.Entity_Details || {};
        let selected = Object.keys(order);
        setSelectedOrders(selected);
        if (JSON.parse(localStorage.getItem(c.ORDER_DATA))) {
            let filters = JSON.parse(localStorage.getItem(c.ORDER_DATA))
            setOrderFilters(filters);
        } else {
            setOrderFilters(prevState => {
                return { ...prevState, ...defaultDates }
            });
            getOrderCategoryList();
        }
    }, []);

    useEffect(() => {
        if (Object.hasOwn(orderFilters, "fromDate")) {
            setOrdersData(null);
            setLoader(true);
            localStorage.setItem(c.ORDER_DATA, JSON.stringify(orderFilters));
            var query = {
                doc_id: data.ID,
                status: orderFilters.status,
                do_status_filter: true,
                do_intent_filter: true,
                bearer_token: "",
                category: orderFilters?.category?.toString() || ""
            };
            api
                .patient_orders(query)
                .then((response) => {
                    if (response.status === 200) {
                        let sortedData = sortByDate(response.data.data);
                        sortedData.forEach((m, i) => {
                            m.s_no = i + 1;
                        });
                        setOrdersData(sortedData);
                    }
                })
                .catch((error) => {
                    setLoader(false);
                });
        }
    }, [orderFilters])

    const getOrderCategoryList = () => {
        // api to get order category list data
    }

    const sortByDate = (data) => {
        var res = "";
        res = data.sort((a, b) => {
            let start = a.authoredOn && new Date(a.authoredOn), end = b.authoredOn && new Date(b.authoredOn);
            if (start < end) return 1;
            if (start > end) return -1;
            return 0;
        }
        );
        return res;
    };

    useEffect(() => {
        setPagination(() => {
            return {
                ...pagination,
                totalRecords: ordersData?.length || 0
            }
        });

    }, [ordersData]);

    useEffect(() => {
        filterData();
    }, [pagination]);

    const handleDate = (date, value) => {
        if (date === "from") {
            setOrderFilters(prevState => {
                return { ...prevState, fromDate: value }
            });
        } else {
            setOrderFilters(prevState => {
                return { ...prevState, toDate: value }
            });
        }
    };

    const handleChange = (type, e) => {
        if (type) {
            setOrderFilters(prevState => {
                return { ...prevState, [type]: e }
            });
        }
    };

    const resetFilter = () => {
        setOrderFilters(prevState => {
            return { ...prevState, category: "", status: "", fromDate: "", toDate: "" }
        });
    };

    const handleOrdersSelection = (event, data) => {
        const new_selected_orders = [...selectedOrders];
        if (event.target.checked) {
            new_selected_orders.push(data.identifier);
        } else {
            new_selected_orders = new_selected_orders.filter(m => m != data.identifier);
        }
        setSelectedOrders(new_selected_orders);
    }

    const handleChangePage = (event, pageNum) => {
        setPagination(() => {
            return {
                ...pagination,
                currentPage: pageNum,
                startRecord: pageNum * pagination.recordsPerPage
            }
        });
    }

    const filterData = () => {
        let data = (ordersData || []).slice(pagination.startRecord, pagination.startRecord + pagination.recordsPerPage);
        setDisplayData(data);
        setLoader(false)
    }

    const handleSubmit = () => {
        let finalSelected = ordersData.reduce((acc, m) => {
            if(selectedOrders.includes(m.identifier)) {
                acc[m.identifier] = {
                    "identifier": m.identifier,
                    "authoredOn": m.authoredOn,
                    "code": m.code
                }
            }
            return acc;
        }, {});

        let result = {...data }
        if(!result.Entity_Details.ehrDetails) result.Entity_Details.ehrDetails = { order: finalSelected }
        else result.Entity_Details.ehrDetails.order = finalSelected;
        setDocumentData({...result});
        props.setEhrPopup(false);
        setDataSave(true);
    }   

    const handleCancel = () => {
        props.setEhrPopup(false);
    }

    return <>
        <div className={loader ? "block-area-common enc-filters orders-tab" : "enc-filters orders-tab"}>
            <div className="enc-filter-fields">
                <div >
                    <div>Status</div>
                    <FormControl style={{ width: "120px", marginRight: "10px" }}>
                        <Select
                            variant="standard"
                            value={orderFilters.status}
                            onChange={(e) => handleChange("status", e.target.value)}
                            inputProps={{
                                name: "status",
                                id: "age-native-simple",
                            }}
                        >
                            <option value="" disabled />
                            {/* <option  value="Draft">Draft</option> */}
                            <option value="Active">Active</option>
                            <option value="Completed">Completed</option>
                            {/* <option  value="Revoked">Revoked</option> */}
                            <option value="Unknown">Unknown</option>

                        </Select>
                    </FormControl>
                </div>
                <div >
                    <div>Category</div>
                    <Autocomplete
                        options={orderCategoryList || []}
                        name="category"
                        id="category-box-demo"
                        value={selectedCategory || null}
                        onChange={(e, val) => handleChange("category", val?.id || "")}
                        sx={{ width: 200 }}
                        renderInput={(params) => (
                            <TextField {...params} variant="standard" />
                        )}
                    />
                </div>
                <Grid style={{ paddingRight: "10px", display: "flex", alignItems: "flex-end", marginLeft: "10px" }}>
                    <CustomDatePicker
                        maxDate={GetCurrentDateAndTime("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate("from", val)
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        label="From"
                        format={'MM/DD/YYYY'}
                        variant="standard"
                        id="fromDate"
                        type="date"
                        value={FormatDate({ date: orderFilters.fromDate, format: "MM/DD/YYYY" })}
                        name="fromDate"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid style={{ paddingRight: "10px", display: "flex", alignItems: "flex-end" }}>
                    <CustomDatePicker
                        minDate={FormatDate({ date: orderFilters.fromDate, format: "MM/DD/YYYY" })}
                        maxDate={GetCurrentDateAndTime("MM/DD/YYYY")}
                        onChange={val => {
                            setDateError(false);
                            handleDate('to', val);
                        }}
                        onError={error => {
                            if (error) setDateError(true);
                            else setDateError(false);
                        }}
                        value={FormatDate({ date: orderFilters.toDate, format: "MM/DD/YYYY" })}
                        label="To"
                        format={'MM/DD/YYYY'}
                    />
                </Grid>
            </div>
            <div className="buttons-filter">
                <button
                    className="reset-button"
                    onClick={resetFilter}
                    style={{ cursor: "pointer", width: "unset" }}
                >
                    <p className="reset-button-text">Get All Orders</p>
                </button>
            </div>
        </div>
        <br />
        <EhrOrdersTable
            loader={loader}
            documentLevel={data?.Entity_Details?.classify?.documentLevel}
            ordersData={displayData}
            pagination={pagination}
            selectedOrders={selectedOrders}
            handleChangePage={handleChangePage}
            handleOrdersSelection={handleOrdersSelection}
        />
        {props.selectedTab == 3 && data?.Entity_Details?.classify?.documentLevel === "Order" && (
          <div className="div-center">
            <button
              className="apply-button"
              type="submit"
              onClick={handleSubmit}
            >
              <p className="apply-button-text">Done</p>
            </button>
            <button
              className="reset-button"
              type="submit"
              onClick={handleCancel}
            >
              <p className="reset-button-text">Cancel</p>
            </button>
          </div>
        )}
    </>
}

export default Orders;